import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelGoogleIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 12 12"
      >
        <path
          d="M3.3051 2.94995L0.275102 8.76995C0.134945 9.00328 0.0426545 9.26218 0.00361643 9.53155C-0.0354217 9.80092 -0.0204262 10.0754 0.047728 10.3389C0.115882 10.6024 0.235831 10.8497 0.400575 11.0664C0.56532 11.283 0.771562 11.4647 1.00727 11.6008C1.24298 11.7369 1.50343 11.8248 1.77343 11.8591C2.04344 11.8935 2.31759 11.8738 2.57989 11.8011C2.84219 11.7284 3.08739 11.6042 3.30118 11.4358C3.51497 11.2673 3.69307 11.058 3.8251 10.82L5.5751 7.44995L3.5751 3.58495C3.45998 3.38487 3.36933 3.17167 3.3051 2.94995ZM3.1751 10.45C3.04657 10.6727 2.85485 10.8523 2.6242 10.9661C2.39356 11.0799 2.13435 11.1227 1.87938 11.0891C1.6244 11.0555 1.38511 10.9471 1.19179 10.7775C0.998465 10.6078 0.859788 10.3847 0.793306 10.1363C0.726823 9.88784 0.735521 9.62527 0.8183 9.38178C0.901079 9.13829 1.05422 8.92482 1.25834 8.76838C1.46247 8.61195 1.70841 8.51957 1.96505 8.50294C2.22169 8.48631 2.47749 8.54617 2.7001 8.67495C2.8476 8.7599 2.9769 8.87309 3.08061 9.00805C3.18432 9.14301 3.26041 9.29709 3.30453 9.46148C3.34864 9.62587 3.35992 9.79735 3.33771 9.9661C3.3155 10.1349 3.26025 10.2976 3.1751 10.445V10.45Z"
          fill="#F7F9FD"
        />
        <path
          d="M11.7251 8.76994L7.7751 1.17993C7.49828 0.719114 7.05154 0.385464 6.53109 0.250858C6.01065 0.116252 5.45815 0.191463 4.99263 0.460288C4.5271 0.729113 4.18579 1.17004 4.04223 1.68809C3.89867 2.20613 3.96434 2.75984 4.2251 3.22993L8.1751 10.8199C8.45191 11.2808 8.89866 11.6144 9.4191 11.749C9.93955 11.8836 10.492 11.8084 10.9576 11.5396C11.4231 11.2708 11.7644 10.8298 11.908 10.3118C12.0515 9.79374 11.9859 9.24003 11.7251 8.76994Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
